module.exports = __webpack_public_path__ + "static/TalkDesk-d69cf9d22ae6bff2177acca39f05d87e.jpg";